import { createRouter } from "@tanstack/react-router"

import type { RouterHistory } from "@tanstack/react-router"
import { parseAppSearch, stringifyAppSearch } from "./lib/search-params"
import { routeTree } from "./routes"

export function createAppRouter(history?: RouterHistory) {
	return createRouter({
		routeTree,
		history,
		parseSearch: parseAppSearch,
		stringifySearch: stringifyAppSearch,
		// Pages that take a #hash scroll to it themselves, smoothly.
		defaultHashScrollIntoView: false,
	})
}

declare module "@tanstack/react-router" {
	interface Register {
		router: ReturnType<typeof createAppRouter>
	}
}
